<div class="pap-autoevaluation-filter border-r-16" *transloco="let t">
  <div class="left-section" [formGroup]="filterForm">
    <div class="form-group" *ngIf="teachers$ | async as teachers">
      <ng-select
        id="teacher"
        formControlName="teacherId"
        [items]="teachers"
        bindLabel="fullName"
        bindValue="id"
        [placeholder]="t('pap/autoEvaluation/teacher')"
        class="form-control form-control-rounded floating-placeholder"
        [ngClass]="{ active: !!filterForm.get('teacherId')?.value }"
        [typeahead]="fetchTeachers$"
        [minTermLength]="2"
      ></ng-select>
    </div>
    <div class="form-group">
      <ng-select
        id="autoEvaluationState"
        formControlName="state"
        [items]="autoEvaluationStateData"
        bindLabel="text"
        bindValue="value"
        [placeholder]="t('pap/autoEvaluation/state')"
        [searchable]="false"
        class="form-control form-control-rounded floating-placeholder"
        [ngClass]="{ active: !!filterForm.get('state')?.value }"
      >
      </ng-select>
    </div>
  </div>

  <div class="right-section">
    <button (click)="exportPage()" class="btn btn-outline-primary btn-icon">
      <i class="material-symbols-rounded">download</i>
      {{ t('shared/export') }}
    </button>
  </div>
</div>
